import React from 'react';

import Query from 'esri/tasks/query';
import QueryTask from 'esri/tasks/QueryTask';
import Point from 'esri/geometry/Point';
import SpatialReference from 'esri/SpatialReference';

import { Promise as bbPromise } from 'promise';

import { criteriaStore } from 'stores/CriteriaStore';
import { reportStore } from 'stores/ReportStore';

import standardsConfig from 'js/standards.config';

const queryTsunami = (location, load) => {
  const version = criteriaStore.getState().standardsVersion;

  let url;

  if (version === '7-22') {
    url = standardsConfig[version].tsunamiServices.tsunamiDesignZone;
  } else {
    let queryLayerId = standardsConfig[version].tsunamiQueryLayerId;
    url = load.layers.query.url + queryLayerId;
  }

  let queryTask = new QueryTask(url);
  let query = new Query();
  query.outFields = ['*'];
  query.where = '1=1';
  query.returnGeometry = false;
  let geo = new Point(location.long, location.lat, new SpatialReference({ wkid: 4326 }));
  query.geometry = geo;

  return new bbPromise((resolve, reject) => {
    try {
      queryTask.execute(query).then(
        (results) => {
          load.showInReport = true;
          if (results.features.length === 0) {
            load.sampleData.value = ['Not in mapped tsunami design zone.'];
            load.details = [
              {
                type: 'singleLine',
                label: '',
                value: 'Not in mapped tsunami design zone.',
              },
            ];
            load.details.push({
              type: 'note',
              note: 'Value provided indicates whether or not the selected site lies within a tsunami design zone.',
            });
            load.details.push({
              type: 'dataSource',
              dataSource: {
                hyperlinkUrl: standardsConfig[version].tsunamiDataSourceLink,
                hyperlinkText: standardsConfig[version].tsunamiDataSource,
              },
            });
          } else {
            // load.sampleData.value = ['In mapped tsunami design zone'];
            load.sampleData.value = [
              'In mapped tsunami design zone.',
              `Go to ${standardsConfig[version].tsunamiDataSourceLink}`,
              'for more information.',
            ];
            load.details = [
              {
                type: 'note',
                note: '',
                hyperlinkUrl: standardsConfig[version].tsunamiDataSourceLink,
                hyperlinkText: '',
                jsxLabel: (
                  <span>
                    In mapped tsunami design zone. Go to{' '}
                    <a href={standardsConfig[version].tsunamiDataSourceLink} target='_blank'>
                      {standardsConfig[version].tsunamiDataSourceLink}
                    </a>{' '}
                    for more information.
                  </span>
                ),
              },
            ];

            load.details.push({
              type: 'note',
              note: 'Value provided indicates whether or not the selected site lies within a tsunami design zone.',
            });
            load.details.push({
              type: 'dataSource',
              dataSource: {
                hyperlinkUrl: standardsConfig[version].tsunamiDataSourceLink,
                hyperlinkText: standardsConfig[version].tsunamiDataSource,
              },
            });
          }
          reportStore.emitChange();
          resolve({ load: load.label });
        },
        (error) => reject({ load: load.label, error })
      );
    } catch (error) {
      reject({ load: load.label, error });
    }
  });
};

export default queryTsunami;
